import { FC, HTMLAttributes, memo } from 'react'

// use https://jakearchibald.github.io/svgomg/ to optimize SVGs
const variants = {
  'caret-down': (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        d="M14 6.9L12.5 5.5L8 9.7L3.5 5.5L2 6.9L8 12.5L14 6.9Z"
        fill="currentColor"
        className="icon-base"
      ></path>
      <title>Caret Down</title>
    </svg>
  ),
  'caret-up': (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        d="M2.02441 10.5992L3.49975 12.0251L8.07237 7.90431L12.4984 12.1822L14.0226 10.8086L8.12123 5.10474L2.02441 10.5992Z"
        fill="currentColor"
        className="icon-base"
      ></path>
      <title>Caret Up</title>
    </svg>
  ),
  equal: (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <rect x="2" y="7" width="12" height="2" fill="currentColor"></rect>
      <title>equal</title>
    </svg>
  ),
  info: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Information icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM7 5.0122C7 4.45122 7.45122 4 8 4C8.56098 4 9 4.45122 9 5.0122C9 5.54878 8.56098 6 8 6C7.45122 6 7 5.54878 7 5.0122ZM7 12V7H9V12H7Z"
        fill="#0157FF"
      />
    </svg>
  ),
  arrow: (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        d="M20 12L13.8863 18L12.3579 16.5L15.7204 13.2H3V10.8H15.7204L12.3579 7.5L13.8863 6L20 12Z"
        className="Icon-glyph"
        fill="currentColor"
      ></path>
      <title>Arrow Right</title>
    </svg>
  ),
  'mortgage-percent': (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.998 0.000488281L10.999 5.00049V1.00049H3.999L4 12.0005H3.999L0 15.9995L1.454 17.4545L3.999 14.9085L3.998 31.9995H27.999V25.9995H26L25.999 30.0005H5.998L5.999 12.9095L16 2.90849L25.999 12.9085V22.0005H27.999V14.9085L30.545 17.4545L31.999 15.9995L16 0.00148828L15.999 0.000488281H15.998ZM5.999 3.00049H9.001L9 6.99949L5.999 10.0015V3.00049Z"
        fill="currentColor"
        className="text-grey"
      ></path>{' '}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 18C10.449 18 10 17.552 10 17C10 16.448 10.449 16 11 16C11.551 16 12 16.448 12 17C12 17.552 11.551 18 11 18ZM14 17C14 15.346 12.654 14 11 14C9.346 14 8 15.346 8 17C8 18.654 9.346 20 11 20C12.654 20 14 18.654 14 17ZM21 24C21.551 24 22 24.448 22 25C22 25.552 21.551 26 21 26C20.449 26 20 25.552 20 25C20 24.448 20.449 24 21 24ZM21 28C22.654 28 24 26.654 24 25C24 23.346 22.654 22 21 22C19.346 22 18 23.346 18 25C18 26.654 19.346 28 21 28ZM20.9498 14.6358L22.3638 16.0498L11.0508 27.3638L9.6358 25.9498L20.9498 14.6358Z"
        fill="currentColor"
        className="text-blue"
      ></path>{' '}
      <title>Mortgage Percent</title>
    </svg>
  ),
  'mortgage-market': (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21H26V12H12V21ZM10 23H28V10H10V23Z"
        fill="currentColor"
        className="text-grey"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0V4H0V6H4V32H6V6H32V4H6V0H4Z"
        fill="currentColor"
        className="text-blue"
      ></path>
      <title>Mortgage Market</title>
    </svg>
  )
}

interface IconProps extends HTMLAttributes<HTMLSpanElement> {
  variant: keyof typeof variants
}

const Icon: FC<IconProps> = ({ className = '', variant, ...rest }) => {
  return (
    <span className={`Icon ${className}`} {...rest}>
      {variants[variant]}
    </span>
  )
}

export default memo(Icon)
